import { init } from './custom-element/registry';
import { CANVAS_EFFECT_READY_EVENT, CANVAS_EFFECT_PLAY_EVENT, CANVAS_EFFECT_STOP_EVENT, CANVAS_SOURCE_UPDATE_EVENT, CANVAS_TARGET_RESIZE_EVENT } from './custom-element/WixMediaCanvas';
import contextManager from './custom-element/contextManager';
function initCustomElement(services, contextWindow) {
  if (services === void 0) {
    services = {
      getPageReady: () => Promise.resolve(),
      contextManager
    };
  }
  if (contextWindow === void 0) {
    contextWindow = null;
  }
  if (typeof window === 'undefined') {
    return;
  }

  // TODO: this can be removed after TB is updated with the new context manager
  if (!services.contextManager) {
    services.contextManager = contextManager;
  }
  const define = init(contextWindow, services);
  define == null || define();
}
export { initCustomElement, CANVAS_EFFECT_READY_EVENT, CANVAS_EFFECT_PLAY_EVENT, CANVAS_EFFECT_STOP_EVENT, CANVAS_SOURCE_UPDATE_EVENT, CANVAS_TARGET_RESIZE_EVENT };
//# sourceMappingURL=initCustomElement.js.map